<template>
  <div class="index">
    <div class="index-con">
      <div class="login-con">
        <div class="index-title">Conference registration</div>
        <div class="steps">
          <el-steps align-center :active="active" finish-status="success">
            <el-step title="Registration form"></el-step>
            <el-step title="Payment"></el-step>
            <el-step title="Terms of payment"></el-step>
          </el-steps>
        </div>
        <div class="one-con">
          <div class="login-cons">
            <div class="login-center">
              <div class="login-list">
                <p class="login-title">First Name*</p>
                <input type="text" placeholder="First Name" v-model="Firstname" />
              </div>
              <div class="login-list">
                <p class="login-title">Middle Name:</p>
                <input type="text" placeholder="Middle Name" v-model="Middlename" />
              </div>
              <div class="login-list">
                <p class="login-title">Last Name*</p>
                <input type="text" placeholder="Last Name" v-model="Lastname" />
              </div>
              <div class="login-list">
                <p class="login-title">Email*</p>
                <el-input type="text" disabled placeholder="Email" v-model="email"></el-input>
              </div>
              <div class="login-list">
                <p class="login-title">Attendee’s Name*:</p>
                <input type="text" v-model="Attendeename"
                  placeholder="For Group Registration, please fill in all the attendees' names here" />
              </div>
            </div>
          </div>
          <div class="reg-type">
            <div>
              <div class="reg-type-title bg-blue">Registration type</div>
              <div class="reg-type-lists">
                <div class="reg-type-list">
                  <p>Delegate : 500 USD</p>
                  <div class="reg-type-nums">
                    <div class="reg-type-jian" @click="jian(1)">-</div>
                    <input v-model="Delegate_num" type="text" class="reg-type-num" />
                    <div class="reg-type-jia" @click="jia(1)">+</div>
                  </div>
                </div>
                <div class="reg-type-list">
                  <p>Student : 250 USD</p>
                  <div class="reg-type-nums">
                    <div class="reg-type-jian" @click="jian(2)">-</div>
                    <input v-model="Student_num" type="text" class="reg-type-num" />
                    <div class="reg-type-jia" @click="jia(2)">+</div>
                  </div>
                </div>
                <div class="reg-type-list">
                  <p>Accompanying person: 150 USD</p>
                  <div class="reg-type-nums">
                    <div class="reg-type-jian" @click="jian(4)">-</div>
                    <input v-model="Accompanying_num" type="text" class="reg-type-num" />
                    <div class="reg-type-jia" @click="jia(4)">+</div>
                  </div>
                </div>
                <div class="reg-type-list">
                  <p>Delegate (Early bird): 450 USD</p>
                  <div class="reg-type-nums">
                    <div class="reg-type-jian" @click="jian(6)">-</div>
                    <input v-model="Early_bird_num" type="text" class="reg-type-num" />
                    <div class="reg-type-jia" @click="jia(6)">+</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="reg-type">
            <div>
              <div class="reg-type-title bg-green">Extras</div>
              <div class="reg-type-lists">
                <div class="reg-type-list">
                  <p>Banquet & Cultural activity : 50 USD</p>
                  <div class="reg-type-nums">
                    <div class="reg-type-jian" @click="jian(5)">-</div>
                    <input v-model="Banquet_num" type="text" class="reg-type-num" />
                    <div class="reg-type-jia" @click="jia(5)">+</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-20">
            <div class="pay-contents">
              <div class="reg-type-title pay-title">
                Officical Receipt (Invoice):
              </div>
              <div class="pay-con">
                <div class="pay-list flex-1">
                  <p>Bill to *</p>
                  <input type="text" placeholder="Organization/Individual" v-model="Billto" />
                </div>
              </div>
              <div class="pay-con">
                <div class="pay-list flex-1">
                  <p>Any Remarks</p>
                  <input type="text" v-model="Remarks" />
                </div>
              </div>
            </div>

            <div class="lists">
              <div class="offical-list">
                <p>Comments:</p>
                <textarea class="textarea" name="" id="" cols="30" rows="5" v-model="Comments"></textarea>
              </div>
            </div>
            <div class="sub-mit" @click="subFn">submit</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      Firstname: '',
      Lastname: '',
      Middlename: '',
      Attendeename: '',
      active: 0,
      Delegate_num: 0,
      Student_num: 0,
      Accompanying_num: 0,
      Banquet_num: 0,
      Early_bird_num: 0,

      Billto: '',
      Remarks: '',
      Comments: '',
      email: '',
      visitor_id: ""
    };
  },
  mounted() {
    var token = localStorage.getItem("token");
    this.visitor_id = localStorage.getItem("visitor_id");
    if (!token) {
      this.$router.push("/login");
      return;
    }
    this.email = localStorage.getItem("email");
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.$http.get_info({
        visitor_id: this.visitor_id,
        email: this.email
      }).then(res => {
        let con = res.data.data[0];
        this.Firstname = con.Firstname ? con.Firstname : "";
        this.Lastname = con.Lastname ? con.Lastname : "";
        this.Middlename = con.Middlename ? con.Middlename : "";
        this.Attendeename = con.Attendeename ? con.Attendeename : "";
        this.Billto = con.Billto ? con.Billto : "";
        this.Remarks = con.Remarks ? con.Remarks : "";
        this.Comments = con.Comments ? con.Comments : "";

        this.Delegate_num = con.Delegate_num
        this.Student_num = con.Student_num
        this.Accompanying_num = con.Accompanying_num
        this.Early_bird_num = con.Early_bird_num
        this.Banquet_num = con.Banquet_num
        console.log(res.data.data[0], '--------')
      })
    },
    subFn() {
      if (!this.Firstname) {
        this.$message.error("Please enter Firstname");
        return
      }
      if (!this.Lastname) {
        this.$message.error("Please enter Lastname");
        return
      }
      if (!this.Attendeename) {
        this.$message.error("Please enter Attendee’s Name");
        return
      }
      if (!this.Billto) {
        this.$message.error("Please enter Bill to");
        return
      }
      this.$http.update_register({
        email: this.email,
        Firstname: this.Firstname,
        Lastname: this.Lastname,
        Middlename: this.Middlename,
        Attendeename: this.Attendeename,
        Delegate_num: this.Delegate_num,
        Delegate_total: this.Delegate_num * 500,
        Student_num: this.Student_num,
        Student_total: this.Student_num * 250,
        Accompanying_num: this.Accompanying_num,
        Accompanying_total: this.Accompanying_num * 150,
        Early_bird_num: this.Early_bird_num,
        Early_bird_total: this.Early_bird_num * 450,
        Banquet_num: this.Banquet_num,
        Banquet_total: this.Banquet_num * 50,
        Billto: this.Billto,
        Remarks: this.Remarks,
        Comments: this.Comments,
      }).then(res => {
        let con = res.data;
        localStorage.setItem("Firstname", con.Firstname);
        localStorage.setItem("Lastname", con.Lastname);
        this.$message.success(res.msg)
        this.$router.push('/register2')
      })

    },
    jian(index) {
      console.log(index)
      if (index == 1) {
        this.Delegate_num--;
        if (this.Delegate_num <= 0) {
          this.Delegate_num = 0;
        }
      }
      if (index == 2) {
        this.Student_num--;
        if (this.Student_num <= 0) {
          this.Student_num = 0;
        }
      }
      if (index == 4) {
        this.Accompanying_num--;
        if (this.Accompanying_num <= 0) {
          this.Accompanying_num = 0;
        }
      }
      if (index == 5) {
        this.Banquet_num--;
        if (this.Banquet_num <= 0) {
          this.Banquet_num = 0;
        }
      }
      if (index == 6) {
        this.Early_bird_num--;
        if (this.Early_bird_num <= 0) {
          this.Early_bird_num = 0;
        }
      }
    },
    jia(index) {
      if (index == 1) {
        this.Delegate_num++;
      }
      if (index == 2) {
        this.Student_num++;
      }
      if (index == 4) {
        this.Accompanying_num++;
      }
      if (index == 5) {
        this.Banquet_num++;
      }
      if (index == 6) {
        this.Early_bird_num++;
      }
    },
    toBank() {
      this.$router.push("/bank");
    },
    next() {
      if (this.active++ > 2) this.active = 0;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
  },
};
</script>
<style scoped>
.steps {
  padding: 30px;
  box-sizing: border-box;
}

.index-con {
  width: 1200px;
  margin: 0 auto;
}

.login-con {
  margin-top: 20px;
}


input::placeholder {
  color: #b9c0c2;
}

.index-title {
  font-size: 18px;
  font-weight: 500;
  height: 60px;
  line-height: 60px;
  padding-left: 20px;
  box-sizing: border-box;
  background: #f5f5f5;
  border-bottom: 1px solid #ddd;
}

.login-con {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 30px;
}

.login-cons {
  padding: 90px 20px 20px;
  box-sizing: border-box;
}

.df {
  display: flex;
  align-items: center;
}

.df .login-title {
  margin-right: 20px;
}

.login-center {
  width: 100%;
  display: flex;
  margin: 0 auto;
  flex-wrap: wrap;
}

.login-title {
  font-weight: 600;
  margin-bottom: 10px;
}

.login-list {
  margin-bottom: 20px;
  width: calc(33% - 20px);
  margin-top: 20px;
}

.login-list:nth-of-type(3n-1) {
  margin: 20px 20px 0;
}

.login-list input {
  width: 100%;
  padding-left: 10px;
  box-sizing: border-box;
  color: #555;
  height: 42px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.login-btn {
  color: #fff;
  background-color: #428bca;
  border: 1px solid #357ebd;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 16px;
  margin-bottom: 15px;
  display: inline-block;
}

.login-text {
  margin-bottom: 15px;
}

.text-blue {
  color: #428bca;
  cursor: pointer;
}

.reg-type {
  padding: 20px;
  box-sizing: border-box;
}

.reg-type>div {
  border: 1px solid #ccc;
  border-radius: 4px;
}

.reg-type-title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #ccc;
  text-indent: 20px;
  background: #d9edf7;
}

.reg-type-lists {
  display: flex;
  flex-wrap: wrap;
}

.reg-type-list {
  width: 50%;
  align-items: center;
  padding: 10px 20px;
  box-sizing: border-box;
  display: flex;
  padding-right: 60px;
  justify-content: space-between;
}

.reg-type-nums {
  display: flex;
}

.reg-type-jian,
.reg-type-jia {
  width: 30px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  border: 1px solid #ccc;
  margin: 0 6px;
  user-select: none;
  border-radius: 4px;
  cursor: pointer;
  background: #eee;
}

.reg-type-num {
  width: 40px;
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 4px;
}


.p-20 {
  padding: 20px;
  box-sizing: border-box;
}

.add-pay-btn {
  color: #fff;
  background-color: #5bc0de;
  border-color: #46b8da;
  width: auto;
  display: inline-block;
  margin: 20px 0;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
}

.tip {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px;
  color: #8a6d3b;
  background-color: #fcf8e3;
  border-color: #faebcc;
}

.pay-contents {
  border: 1px solid #ccc;
  border-radius: 4px;
}

.pay-title {
  background: #fcf8e3;
}

.pay-con {
  padding: 20px;
  box-sizing: border-box;
  display: flex;
}

.pay-list>input {
  height: 40px;
  padding-left: 10px;
  width: 100%;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
}

.flex-1 {
  flex: 1;
}

.pay-list>p {
  margin-bottom: 4px;
}

.m-20 {
  margin: 0 20px;
}

.offical-cons {
  margin-bottom: 20px;
  margin-top: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.offical-title {
  background: #eee;
}

.offical-lists {
  padding: 20px;
  box-sizing: border-box;
}

.offical-list {
  margin-bottom: 20px;
}

.offical-list p {
  margin-bottom: 4px;
}

.offical-list input {
  height: 40px;
  width: 100%;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
}

.offical-list-select {
  width: 100%;
  margin-bottom: 10px;
}

.textarea {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  width: 100%;
}

.sub-mit {
  width: auto;
  display: inline-block;
  padding: 10px 46px;
  cursor: pointer;
  font-size: 18px;
  line-height: 1.33;
  border-radius: 6px;
  color: #fff;
  background-color: #5cb85c;
}

.reg-type-title {
  background: #eee;
}

.two-con {
  border-radius: 4px;
  width: 1000px;
  margin: 10px auto;
  border: 1px solid #ccc;
}

.two-cons {
  padding: 20px;
  box-sizing: border-box;
}

.two-lists {
  border: 1px solid #ccc;
  border-radius: 4px;
}

.two-list,
.two-fee-list {
  display: flex;
  height: 35px;
  align-items: center;
  text-indent: 15px;
  line-height: 35px;
  border-bottom: 1px solid #ccc;
}

.bg-green {
  background: #dff0d8;
}

.bg-blue {
  background: #d9edf7;
}

.two-list p:nth-of-type(1) {
  border-right: 1px solid #ccc;
  width: 35%;
  height: 35px;
}

.two-list p:nth-of-type(2) {
  flex: 1;
  height: 35px;
}

.two-list:nth-of-type(2n) {
  background: #eee;
}

.two-fee-lists {
  margin-top: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fcf8e3;
}

.two-fee-list:nth-of-type(1) {
  background: #fff;
}

.two-fee-list p {
  width: 25%;
  border-right: 1px solid #ccc;
}

.two-fee-list p:nth-last-of-type(1) {
  border-right: 0;
}

.two-lists .two-list:nth-last-of-type(1),
.two-fee-lists .two-fee-list:nth-last-of-type(1) {
  border-bottom: 0;
}

.bg-red {
  background: #f2dede;
  color: #f53f3f;
  font-size: 26px;
  height: 60px;
  font-weight: 600;
}

.two-fee-list.bg-red p {
  height: 60px;
  line-height: 60px;
}

.two-phone-blue-tip {
  color: #31708f;
  border: 1px solid transparent;
  background-color: #d9edf7;
  border-color: #bce8f1;
  padding: 15px;
  margin-bottom: 20px;
  border-radius: 4px;
  margin-top: 10px;
}

.two-phone-title {
  margin-top: 20px;
  margin-bottom: 10px;
}

.two-phone-btns {
  display: flex;
  align-items: center;
  justify-content: center;
}

.two-phone-btn {
  border: 1px solid transparent;
  color: #fff;
  background-color: #5bc0de;
  border-color: #46b8da;
  padding: 10px 16px;
  font-size: 18px;
  line-height: 1.33;
  border-radius: 6px;
  cursor: pointer;
  margin: 0 15px;
}

.two-phone-btn:nth-of-type(2) {
  background-color: #5cb85c;
  border-color: #4cae4c;
}

.three-con {
  width: 1000px;
  margin: 0 auto 40px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.three-cons {
  padding: 20px;
  box-sizing: border-box;
}

.three-tip {
  background: #dff0d8;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.bank-img {
  width: 350px;
  height: auto;
  broder: 4px solid #bce8f1;
  border-radius: 4px;
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .login-tip {
    font-size: 14px;
    text-indent: 10px;
  }

  .login-list input {
    width: 100%;
  }

  .info-small-title {
    height: auto;
  }

  .login-center {
    width: 100%;
  }

  .login-list {
    width: 100%;
  }

  .login-list:nth-of-type(3n-1) {
    margin: 20px 0;
  }

  .reg-type-list {
    width: 100%;
    padding-right: 10px;
  }

  .pay-con {
    flex-wrap: wrap;
  }

  .pay-list {
    width: 100%;
  }

  .pay-list:nth-of-type(2) {
    margin: 20px 0;
  }

  .two-con {
    width: 100%;
  }

  .two-list,
  .two-fee-list {
    min-height: 45px;
    line-height: 1.9;
    display: flex;
    align-items: center;
    justify-content: center;
    height: auto;
  }

  .two-list p,
  .two-fee-list p {
    height: 100%;
    min-height: 45px;
    display: flex;
    align-items: center;
  }

  .two-list p:nth-of-type(1) {
    width: 50%;
  }

  .two-phone-btns {
    display: block;
  }

  .two-phone-btn {
    margin: 20px 0;
  }

  .three-con {
    width: 100%;
  }

  .reg-type-title {
    height: auto;
    line-height: 1.4;
    padding: 20px 15px;
    text-indent: 0;
    box-sizing: border-box;
  }

  .bank-img {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/register1.vue